module.exports = __webpack_public_path__ + "img/img_right.23bd50e5.jpg";